export default "__VITE_ASSET__Darva6Yb__"